import React from 'react';
import { StyleSheet, useWindowDimensions, View } from 'react-native';

import VideoPlayer from '@organisms/VideoPlayer';
import { withAuthGate } from '@sunrise-ui/composites';
import {
  Loader,
  useDynamicStyles,
  useSafeLocalSearchParams,
  type WithResponsive,
} from '@sunrise-ui/primitives';
import { defaultBack } from '@utils/navigation';

function WatchScreen() {
  const { width, height } = useWindowDimensions();
  const styles = useDynamicStyles(createStyles);

  const { video, userId } = useSafeLocalSearchParams<{
    video?: string;
    userId?: string;
  }>();
  const smallestDimension = Math.min(width, height - 70);

  return (
    <View style={styles.container}>
      {video && userId ? (
        <VideoPlayer
          url={video}
          userId={userId}
          onFinish={defaultBack()}
          videoDimension={smallestDimension}
        />
      ) : (
        <Loader />
      )}
    </View>
  );
}

const createStyles = ({ isMobile }: WithResponsive) =>
  StyleSheet.create({
    container: {
      flex: isMobile ? undefined : 1,
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
    },
  });

export default withAuthGate(WatchScreen);
